/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../context/AuthContext";

const Header = (props) => {
  const appName = "Consulting Jobs";
  // const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <>
      <meta charSet="utf-8" />
      <title>Job Portal Website</title>
      <meta content="width=device-width, initial-scale=1.0" name="viewport" />
      <meta
        name="keywords"
        content="remote jobs, Remote job openings, remote career opportunities, Work-from-home jobs, Remote positions, telecommute jobs, Remote work opportunities, virtual job listings, emote employment, remote job vacancies"
      />
      <meta
        name="description"
        content="Explore remote job opportunities at Consulting. Find work-from-home positions and join our team of talented professionals."
      ></meta>

      {/* 1. Outer Nav: Handles the background color and full width */}
      <nav className="navbar navbar-expand-lg bg-primary navbar-light sticky-top py-3">
        {/* 2. Inner Container: Constrains the content to the middle */}
        <div className="container">
          <a
            href="/"
            className="navbar-brand d-flex align-items-center text-center"
          >
            <h1 className="m-0 text-white">{appName}</h1>
          </a>

          <button
            type="button"
            className="navbar-toggler"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto p-4 p-lg-0">
              <a
                href="/"
                className={
                  props.path === "/"
                    ? "nav-item nav-link text-white active"
                    : "nav-item nav-link text-white"
                }
              >
                Home
              </a>
              <a
                href="/about"
                className={
                  props.path === "about_us"
                    ? "nav-item nav-link text-white active"
                    : "nav-item nav-link text-white "
                }
              >
                About Us
              </a>
              <a
                href="/jobs"
                className={
                  props.path === "jobs"
                    ? "nav-item nav-link text-white active"
                    : "nav-item nav-link text-white "
                }
              >
                Jobs
              </a>

              <a
                href="/contact"
                className={
                  props.path === "contact"
                    ? "nav-item nav-link text-white active"
                    : "nav-item nav-link text-white "
                }
              >
                Contact
              </a>
            </div>

            {/* {user ? (
              <>
                <a href="/create-jobs" className="nav-item nav-link text-white">
                  Post A Job
                  <i className="fa fa-arrow-right ms-3" />
                </a>

                <button
                  onClick={logout}
                  className="btn rounded-0 py-4 px-lg-5 d-none d-lg-block text-white"
                  style={{
                    backgroundColor: "#fb5d16",
                    color: "#fff",
                    border: "none",
                    fontWeight: "600",
                  }}
                >
                  LOGOUT <i className="fa fa-arrow-right ms-3" />
                </button>
              </>
            ) : (
              <a
                href="/login"
                className="btn rounded-0 py-4 px-lg-5 d-none d-lg-block"
                style={{
                  backgroundColor: "#fb5d16",
                  color: "#fff",
                  fontWeight: "600",
                }}
              >
                LOGIN <i className="fa fa-arrow-right ms-3" />
              </a>
            )} */}
          </div>
        </div>{" "}
        {/* End of Container */}
      </nav>
    </>
  );
};
export default Header;
